import { FormPath } from "../Forms/FormPath";
import { ElementType } from "../Forms/FormTemplateInterfaces";

class QuestionnaireAnswer {
    public PropertyName: string;
    public PropertyPath: string;
    public PropertyType: ElementType;
    public Value: string;

    constructor(fields?: Partial<QuestionnaireAnswer>) {
        Object.assign(this, fields);
    }

    public get formPath(): FormPath {
        if (!this.PropertyPath)
            return null;

        return new FormPath(this.PropertyPath);
    }
}

export { QuestionnaireAnswer };
